export const COLOR_TYPE_ATC:Record<string, any>  = {
   'INCOMING':'#6fff8c',
   'OUTGOING': '#3ed031',
   'ACCEPTED': '#0656F8',
};